import React from 'react';
import './personDetailPage.css'

function PersonDetailPage({ person }) {
  return (
    <div className="personDetailPage">
      <h1>{person.firstName} {person.lastName}</h1>
      <p><strong>Yaş:</strong> {person.age}</p>
      <p><strong>Cinsiyet:</strong> {person.gender}</p>
      <p><strong>Şehir:</strong> {person.city}, {person.district}</p>
      <p><strong>Saç Rengi:</strong> {person.hairColor}</p>
      <p><strong>Göz Rengi:</strong> {person.eyeColor}</p>
      <p><strong>Açıklama:</strong> {person.description}</p>

      <h3>İletişim Bilgileri</h3>
      <p><strong>Telefon:</strong> {person.phoneNumber}</p>

      <h3>Görseller</h3>
      <div className="images">
        {person.imageLinks.map((link, index) => (
          <img key={index} src={link} alt={`${person.firstName} ${index + 1}`} />
        ))}
      </div>

      <h3>Videolar</h3>
      <div className="videos">
        {person.videoLinks.map((link, index) => (
          <video key={index} controls src={link}></video>
        ))}
      </div>

      <h3>Diller</h3>
      <ul>
        {person.languages.map((language, index) => (
          <li key={index}>{language}</li>
        ))}
      </ul>

      <h3>Tarifeler</h3>
      <p><strong>Saatlik:</strong> {person.rates.hourly} TL</p>
      <p><strong>Günlük:</strong> {person.rates.daily} TL</p>

      <h3>Sosyal Tepkiler</h3>
      <p><strong>Beğeni Sayısı:</strong> {person.likeNumber}</p>
      <p><strong>Beğenmeme Sayısı:</strong> {person.dislikeNumber}</p>

      <p><strong>Hizmetler:</strong> {person.incall ? 'Evet' : 'Hayır'} (Eve Gelen), {person.outcall ? 'Evet' : 'Hayır'} (Dışarı Giden)</p>
    </div>
  );
}

export default PersonDetailPage;
